import { useParams } from 'react-router';

import { ProcessingScreenWithStore } from './ProcessingScreen';
import { UploadScreenWithStore } from './UploadScreen';

/**
 * Mascot applet routes:
 * - /mascot → UploadScreen (add mascot jobs)
 * - /mascot/:id → ProcessingScreen (batch status and results)
 */
export default function BatchMascot() {
  const { id: batchId } = useParams<{ id: string }>();

  if (batchId) {
    return (
      <div className="flex w-full flex-col">
        <ProcessingScreenWithStore />
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col">
      <UploadScreenWithStore />
    </div>
  );
}
